import 'slick-carousel';

export default {
    when() {
        return document.querySelectorAll('[data-component="logos"]').length > 0;
    },

    mounted() {
        document
            .querySelectorAll('[data-component="logos"]')
            .forEach((element) => {
                const container = element.querySelector('[data-logos--container]');
                const controls = element.querySelector('[data-logos--controls]');

                $(container).slick({
                    // centerMode: true,
                    slidesToShow: 1,
                    prevArrow:
                        '<div class="cursor-pointer prev-arrow"><img src="/app/themes/cherrypulp/resources/images/slick-arrow-left.svg" alt=""></div>',
                    nextArrow:
                        '<div class="cursor-pointer next-arrow"><img src="/app/themes/cherrypulp/resources/images/slick-arrow-right.svg" alt=""></div>',
                    // prevArrow: '<a class="prev-arrow" style="background-image: url(/app/themes/cherrypulp/resources/images/→-2.svg)"></a>',
                    appendArrows: $(controls),
                    arrows: true,
                    infinite: true,
                    dots: false,
                });
            });
    },
};
